var CAMPAIGN_DELIMITER = '|';
var RECIPE_DELIMITER = ':';
var COOKIE_KEY = 'edm-routes-2';
var COOKIES = require('src/interlock/no-ui/utils/cookies/cookies');
/**
 * the wtf parameter is a part of targeting values, with a value populated if the user was bucketed into an active WTF campaign
 * @public
 * @returns {Object}
 */
function generateWtfContext() {
    var context = {},
        cookieVal = COOKIES.getItem(COOKIE_KEY),
        name,
        value,
        items = [];

    if(cookieVal) {
        cookieVal = cookieVal.replace(/"/g, '');

        var cmps = cookieVal.split(CAMPAIGN_DELIMITER);
        for(var i = 0, len = cmps.length; i < len; i++) {
            var campaign = cmps[i].split(RECIPE_DELIMITER);
            name = campaign[0];
            value = campaign[1];
            if(name.indexOf('_dfp') > -1) {
                items.push(name + '_' + value);
            }
        }
    }
    context.wtf = items.join('|');

    return context;
}

module.exports = generateWtfContext;


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-context/wtf-context-generator.js
// module id = 443
// module chunks = 36